<div class="mapfre-login-footer ">
  <div class="links-section flex" *ngIf="links">
    <div class="links-section__left-section flex jc-c">
      <div class="flex fd-col">
        <div class="title">{{links[0].type | translate}}</div>
        <div class="links flex fd-col jc-c">
          <div (click)="url.open(item.url)"
            *ngFor="let item of links[0]?.links">{{item?.text | translate}}</div>
        </div>
      </div>
    </div>
    <div class="links-section__right-section flex jc-c">
      <div class="flex fd-col">
        <div class="title">{{links[1]?.type | translate}}</div>
        <div class="links flex fd-col jc-c">
          <div (click)="url.open(item.url)"
            *ngFor="let item of links[1].links">{{item?.text | translate}}</div>
          <div onclick="OneTrust.ToggleInfoDisplay()">
            {{'LOGIN.WEB_VERSION.FOOTER.LINKS_LEGAL.COOKIES_CONF' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="social-media-section flex fd-col ai-c">
    <div class="social-media-section__left-section flex jc-c">
      <div>{{'LOGIN.FOOTER.COPYRIGHT_YEAR' | translate : { year : year} }}</div>
    </div>
    <div class="social-media-section__right-section flex jc-c">
      <div class="icons flex">
        <img *ngFor="let icon of socialMediaIcons"
          [src]="icon?.path"
          alt=""
          (click)="url.open(icon?.url)">
      </div>
    </div>
  </div>
</div>